








import Vue from "vue"
import { Component, Prop } from "vue-property-decorator"

@Component
export default class ErrorMessageComponent extends Vue {

    @Prop({ type: Boolean, default: false }) error: boolean


}
